import { useState } from 'react';
import OverlayTrigger from 'components/common/OverlayTrigger/OverlayTrigger';
import { IncompleteResultsMessages } from 'components/search/PowerQueriesPage/components/PowerQueriesContent/PowerQueriesContent';
import SvgIcon from 'components/common/Icon/SvgIcon';

import './DashboardIncompleteResults.scss';

type DashboardIncompleteResultsIconProps = {
  matchCount?: number;
  omittedEvents?: number;
  partialResultsDueToTimeLimit?: boolean;
  rowCount?: number;
};

function DashboardIncompleteResults({
  matchCount = 0,
  omittedEvents = 0,
  partialResultsDueToTimeLimit = false,
  rowCount = 0,
}: DashboardIncompleteResultsIconProps): JSX.Element | null {
  const [show, setShow] = useState(false);

  if (!(omittedEvents || partialResultsDueToTimeLimit)) {
    return null;
  }

  const overlay = (
    <div className="DashboardIncompleteResults__Overlay">
      <IncompleteResultsMessages matchCount={matchCount} omittedEvents={omittedEvents} partialResultsDueToTimeLimit={partialResultsDueToTimeLimit} rowCount={rowCount}/>
    </div>
  );

  return (
    <div className="DashboardIncompleteResults">
      <div className="DashboardIncompleteResults__Icon">
        <SvgIcon type="warning" />
      </div>
      <div className="DashboardIncompleteResults__Message">Incomplete results -</div>
      <OverlayTrigger
        overlay={overlay}
        placement="bottom"
        className="DashboardIncompleteResults__Details"
        showOverlay={show}
        setShowOverlay={setShow}
      >
        <a>Detail</a>
      </OverlayTrigger>
    </div>
    
  );
}

export default DashboardIncompleteResults;
